<script>
    export default {
        name: "MediaCardDescription",
    };
</script>

<template functional>
    <div class="media-card__desc">
        <slot></slot>
    </div>
</template>

<style lang="scss">
    .media-card__desc {
        position: relative;
        max-height: 70px;
        margin-top: 5px;
        color: var(--primary-text);
        font-size: 14px;
        line-height: 22px;
        overflow: hidden;
        &::after {
            content: "";
            position: absolute;
            width: 30%;
            height: 22px;
            right: 0;
            bottom: 0;
            background: linear-gradient(270deg, #fff 15%, hsla(0, 0%, 100%, 0));
        }
    }
</style>
